export const ACTIVITIES = "/api/activities"
export const ACTIVITY = "/api/activity/:param"
export const ACTIVITY_ACTIVATE = "/api/activity/:param/activate"
export const ACTIVITY_DEACTIVATE = "/api/activity/:param/deactivate"
export const EXPORT_ACTIVITY = "/api/activity/export"
export const IMPORT_ACTIVITY = "/api/activity/import"
